export const CloseButtonClick = 'commutifi/useModal/close_button_click'
export const OpenButtonClick = 'commutifi/useModal/open_button_click'
